import React from 'react';
import { ReportData } from '../../types/report.types';
import HtmlEditor from '../HtmlEditor';

interface ProjectObjectivesEditorProps {
  reportData: ReportData;
  onHtmlChange: (field: keyof ReportData, value: string) => void;
}

const ProjectObjectivesEditor: React.FC<ProjectObjectivesEditorProps> = ({
  reportData,
  onHtmlChange,
}) => {
  return (
    <div className="h-full overflow-y-auto">
      <div className="bg-white rounded-xl shadow-lg border border-slate-100 p-6 mb-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-1 h-8 bg-gradient-to-b from-blue-500 to-blue-700 rounded-full" />
          <div>
            <h3 className="text-base font-bold text-blue-900 tracking-tight">Project Objectives</h3>
            <p className="text-xs text-blue-700/80 font-medium mt-0.5">Define the goals and objectives of your security assessment</p>
          </div>
        </div>
        <div className="mb-4">
          <label className="block text-xs font-medium text-slate-700 mb-1">Assessment Date (for Assumptions section)</label>
          <input
            type="date"
            className="w-full px-2.5 py-1.5 text-sm bg-white border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-all duration-200"
            value={reportData.objectives_date || reportData.current_date || ''}
            onChange={e => onHtmlChange('objectives_date', e.target.value)}
          />
          <p className="text-xs text-slate-500 mt-1">This date will be used in the "Assumptions" section text</p>
        </div>
        <div className="pt-2">
          <div className="text-xs">
            <HtmlEditor
              field="project_objectives"
              title=""
              reportData={reportData}
              onHtmlChange={onHtmlChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectObjectivesEditor; 